import Vue from 'vue'
import Vuex from 'vuex'
import authorization from './modules/authorization'
import schoolInfo from './modules/schoolInfo'
import global from './modules/global'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    authorization,
    schoolInfo,
    global
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js